import { BodyText, FieldLabel, Layout } from '@postscript/components';
import { Field, FieldAttributes, useField } from 'formik';
import { nanoid } from 'nanoid';
import React, { useRef } from 'react';
import styled from 'styled-components';

const StyledFieldLabel = styled(FieldLabel)`
  padding: 0;
`;

interface Props extends FieldAttributes<any> {
  name: string;
  children?: React.ReactNode;
  description?: string;
}

export default function FormikField({
  name,
  children,
  description,
  label,
  ...props
}: Readonly<Props>): JSX.Element {
  const [, meta] = useField(name);

  // Avoid ID collisions by prefixing with a unique string
  const id = useRef(`${nanoid()}-${name}`).current;
  const descriptionID = `${id}-description`;

  if (description) {
    return (
      <div>
        <Layout gap="var(--spacing-1)" vertical>
          <div>
            <StyledFieldLabel htmlFor={id}>{label}</StyledFieldLabel>
            <BodyText size="small" id={descriptionID}>
              {description}
            </BodyText>
          </div>
          <Field
            id={id}
            name={name}
            error={meta.touched && meta.error}
            errorMessage={meta.error}
            aria-describedby={descriptionID}
            {...props}
          >
            {children}
          </Field>
        </Layout>
      </div>
    );
  }

  return (
    <Field
      id={id}
      name={name}
      label={label}
      error={meta.touched && meta.error}
      errorMessage={meta.error}
      {...props}
    >
      {children}
    </Field>
  );
}
